import React from 'react';
import './tabbedcontent.scss';

const handelize = (string) => {
	return string.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') ;
}

export const TabbedChild = ({data, active}) => {
	//console.log(data.props)
	return 	<div className={'tabbedchild'} data-handle={handelize(data.props.name)} data-active={active}>
				{data}
			</div>
}


export default class TabbedContent extends React.Component {

	constructor(props){
		super(props);

		this.state = {
			active : 0,
			fade : 'in'
		}
	}

	render(){
		return 	<section className='component tabbedcontent'>
					
					<header>
						<nav>
							{this.props.children.map((item, i) => {
								return <button key={i} onMouseUp={()=>{this.change(i)}} data-active={this.state.active === i} onTouchEnd={()=>{this.change(i)}}>{item.props.name}</button>
							})}
						</nav>
					</header>

					<div className="items" data-fade={this.state.fade}>
						{this.props.children.map((item, i) => {
							return <TabbedChild key={i} data={item} active={this.state.active === i}/>
						})}
					</div>
					
				</section>
	}

	change(i){
		if(i === this.state.active) return;

		this.setState({fade: 'out'}, ()=>{
			setTimeout(()=>{
				this.setState({active : i}, ()=>{
					this.setState({fade: 'in'});
				})
			}, 300)
		})
		
	}
}



// WEBPACK FOOTER //
// ./src/components/tabbedcontent/tabbedcontent.jsx